<div class="certificate-list-entry-container"
     routerLinkActive="active-entry"
     [class.selected-entry]="selected()"
     (contextmenu)="onContextMenu($event)"
>
  <span class="certificate-status-display"
        [attr.data-test]="'certificate-status-' + item().certificateStatus"
        [ngClass]="statusColor()"
  ></span>

  <a class="certificate-link"
     [routerLink]="['/certificate', item().uuid]"
     [title]="name()"
     (click)="onEntryClick($event)"
  >
    <span class="truncate">{{ name() }}</span>
  </a>

  @if (item().documentSent) {
    <span class="sent-indicator"
          data-test="certificate-item-sent-indicator"
          title="Document sent"
    >
      <i class="pi pi-send"></i>
    </span>
  }

  <button class="options-button"
          type="button"
          data-test="certificate-item-options-button"
          [disabled]="optionsDisabled()"
          [title]="optionsDisabled() ? 'Selection active - use right-click for bulk actions' : 'Options'"
          (click)="onOptionsClick()"
  >
    <i class="pi pi-ellipsis-v"></i>
  </button>
</div>
